export const CART_STATUS = {
  UNSTARTED: "unstarted",
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
} as const;
